(() => {
  'use strict';
  if (window.location.pathname.replace(/\/+$/, '') === '/pages/build-your-tmo-collection') return;
  if (window.location.pathname.replace(/\/+$/, '') === '/cart') return;
  if (window.__tmoEssentialCartDeliveryInitialized) return;
  window.__tmoEssentialCartDeliveryInitialized = true;
  // Existing essential-cart logic is intentionally disabled on the TMO collection builder.
})();
